import type { Doodle, ServiceUserAccount } from './models.ts'

export const COUNTS_ATTACHMENT_STORAGE_USAGE = false

export const doodleStorageSize = (doodle: Doodle) =>
  doodle.filesize +
  (COUNTS_ATTACHMENT_STORAGE_USAGE ? Object.values(doodle.attachments ?? {}).reduce((size, a) => size + a.filesize, 0) : 0)

export const userStorageSize = (currentUser: ServiceUserAccount, tenantId: string) => {
  const license = currentUser.tenants?.[tenantId]?.zumeco?.license
  return license ? (license.userStorageSize ?? 1024 ** 3) : 0
}
